import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

class SdsButton extends PureComponent {
  render() {
    const { label, children, disabled, noFullWidth, flatPrimary, variant, style, ...passthrough } = this.props;

    return (
      <button
        className={classnames(
          "sds-btn sds-btn--full-width",
          { "sds-btn--disabled": disabled },
          { "sds-btn--no-full-width": noFullWidth },
          { "sds-btn--raised": !flatPrimary && variant !== "outline" },
          // "outline": botão secundário/contorno (issue #67, telas de login WhatsApp) —
          // reaproveita ".sds-btn--outlined-primary", já existente no design system
          // (public/assets/sds/css/sds.css), sem CSS novo. flatPrimary continua tendo
          // prioridade sobre variant, igual à prioridade que já tinha sobre "raised".
          { "sds-btn--outlined-primary": !flatPrimary && variant === "outline" },
          { "sds-btn--flat-primary": flatPrimary },
        )}
        disabled={disabled}
        style={style}
        {...passthrough}
      >
        {/* "children" (issue #67, achado de QA manual: ícone + texto parcialmente em
            negrito em alguns botões) tem prioridade sobre "label" — usos existentes não
            passam children, então continuam renderizando <FormattedMessage id={label} />
            exatamente como antes. */}
        {children || <FormattedMessage id={label} />}
      </button>
    );
  }
}

SdsButton.defaultProps = {
  // Default preserva o visual "cheio"/raised que todos os usos existentes já tinham
  // antes desta prop existir — só passa a haver diferença quando variant="outline" for
  // passado explicitamente.
  variant: "primary",
  label: undefined,
  children: undefined,
};

SdsButton.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(["primary", "outline"]),
};

export default SdsButton;
